import {Partner} from "./partner.model";

/**
 * Model reprezentujący pojedynczy produkt w module E-commerce (Sklep Partnera).
 */
export class PartnerProduct {

  /** Data pobrania/utworzenia. */
  created: Date;

  /** Pełny obiekt Partnera (właściciela/dostawcy tego produktu). */
  partner: Partner;

  /** Wewnętrzne ID Partnera. */
  partnerId: number;

  /** Globalnie unikalny identyfikator produktu. */
  uuid: string;

  /** Kod kreskowy (European Article Number).
   */
  ean: string;

  /** ID produktu w zewnętrznym systemie dostawcy.
   */
  partnerSystemId: number;

  /** ID atrybutu/wariantu produktu.
   * Pozwala na obsługę produktów posiadających różne warianty.
   */
  idProductAttribute: number;

  /** Bezpośredni link do zdjęcia produktu. */
  pictureUrl: string;

  /** Nazwa produktu. */
  name: string;

  /** Opis produktu. */
  description: string;

  /** Cena netto produktu. */
  price: number;

  /** Cena brutto. */
  grossPrice: number;

  /** Cena promocyjna. */
  discountPrice: number;

  /** Aktualny stan magazynowy (ilość dostępnych sztuk).
   */
  quantity: number;

  /** Tekstowy status dostępności.
   */
  availability: string;

  /** Zserializowane drzewo kategorii w formacie JSON.
   */
  categoriesJson: string;

}
